import React, { useEffect, useState } from 'react';
import './LandingPage.css'; // Assuming you have a CSS file for additional styling
import { TitleSection } from '../../Components/TitleSection/TitleSection';
import { SignInCard } from '../../Components/SignInCard/SignInCard';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';

const LandingPage = () => {
    const { instance } = useMsal();
    const [logo, setLogo] = useState(null);

    const handleLoginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    useEffect(() => {
        //fetchLogo();
    }, []);

    // const fetchLogo = async () => {
    //     let logo = await AppLogoDataService.getAppLogo();
    //     setLogo(logo?.logoUri ?? dm_logo_primary);
    // }

    return (
        <div className='landing-page d-flex'>
            <div className='left-container w-50 d-flex align-items-center justify-content-start'>
                <TitleSection logo={logo} />
            </div>
            <div className='right-container w-50 d-flex align-items-center justify-content-center'>
                <SignInCard containerClass='w-100' cardClass='w-75' onSigninClick={handleLoginRedirect} />
            </div>
        </div>
    );
};

export default LandingPage;